import { aiChatSignalRConnection } from 'app/services/signalR';

import { logger } from 'utils/logger';

import { FrontendToolHandler } from './FrontendToolHandler';

export const frontendToolHandler = new FrontendToolHandler(aiChatSignalRConnection, logger);
